import { defineAction } from '~/prix'
import { z } from 'zod'
import censorDatabaseAction from './censorDatabase.action.json' assert { type: 'json' }

const booleanOption = z.union([
  z.boolean(),
  z.enum(['true', 'false']).transform(value => value === 'true'),
])

const censorDatabaseDefinition = defineAction({
  ...censorDatabaseAction,

  input: z.object({
    includeOlap: booleanOption.default(true).describe('Anonimiza tabelas do ClickHouse'),
    includeOltp: booleanOption.default(true).describe('Anonimiza tabelas do PostgreSQL'),
    seed: z.coerce.number().int().default(123456).describe('Seed base para anonimização determinística'),
    batchSize: z.coerce
      .number()
      .int()
      .min(1)
      .max(1000)
      .default(250)
      .describe('Quantidade de registros processados por lote'),
    limit: z.coerce
      .number()
      .int()
      .positive()
      .nullable()
      .default(null)
      .describe('Limita a quantidade total de registros por tabela'),
  }),
  output: z.object({
    success: z.boolean(),
    startedAt: z.string(),
    finishedAt: z.string(),
    durationMs: z.number(),
    tables: z.array(
      z.object({
        database: z.enum(['oltp', 'olap']),
        table: z.string(),
        processed: z.number(),
        updated: z.number(),
        durationMs: z.number(),
        status: z.enum(['success', 'error', 'skipped']),
        message: z.string().nullable(),
      }),
    ),
    errors: z.array(
      z.object({
        database: z.enum(['oltp', 'olap']),
        table: z.string(),
        message: z.string(),
      }),
    ),
  }),
})

export default censorDatabaseDefinition
